import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { Routes } from 'app/routes/Routes'
import { FC } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import KButton from '../../Modules/General/KButton'

type Props = {
  disabled?: boolean
}

const MachineInteractionButton: FC<Props> = ({ disabled }) => {
  const { tCore } = useTranslation({ scope: 'product_list', recordType: RecordType.line_item })
  const { rental_id } = useParams()
  const navigate = useNavigate()
  const onClick = () => navigate(Routes.Rental.member(String(rental_id)).machine_interaction)
  if (disabled) return

  return (
    <KButton
      recordType={RecordType.line_item}
      action="vacant_or_extend"
      onClick={onClick}
      type="secondary"
      className="full-width"
      title={tCore({ id: 'vacant_or_extend' })}
    />
  )
}

export default MachineInteractionButton
